export default {"src":"/_next/static/media/icon-flag-portugual.58636090.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};